import { useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const InstallmentModal = ({ onClose, onSave }) => {
  const [form, setForm] = useState({
    due_date: "",
    amount: "",
    vat: "",
    document_type: "invoice",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    const total =
      Number(form.amount || 0) + Number(form.vat || 0);

    onSave({
      ...form,
      total,
    });

    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-md bg-slate-900 border border-white/10 rounded-xl shadow-xl">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">
            Add Installment
          </h2>

          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white"
          >
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">

          {/* Due Date */}
          <div>
            <label className="text-sm text-slate-300">
              Due Date
            </label>

            <input
              type="date"
              value={form.due_date}
              onChange={(e) =>
                handleChange("due_date", e.target.value)
              }
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2 text-white"
            />
          </div>

          {/* Amount */}
          <div>
            <label className="text-sm text-slate-300">
              Amount
            </label>

            <input
              type="number"
              value={form.amount}
              onChange={(e) =>
                handleChange("amount", e.target.value)
              }
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2 text-white"
            />
          </div>

          {/* VAT */}
          <div>
            <label className="text-sm text-slate-300">
              VAT (optional)
            </label>

            <input
              type="number"
              value={form.vat}
              onChange={(e) =>
                handleChange("vat", e.target.value)
              }
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2 text-white"
            />
          </div>

          {/* Document Type */}
          <div>
            <label className="text-sm text-slate-300">
              Document Type
            </label>

            <select
              value={form.document_type}
              onChange={(e) =>
                handleChange("document_type", e.target.value)
              }
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2 text-white"
            >
              <option value="invoice">Invoice</option>
              <option value="proforma">Proforma</option>
            </select>
          </div>

        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">

          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-slate-300 hover:bg-slate-800 rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="bg-pink-600 hover:bg-pink-700 px-4 py-2 rounded-lg text-white text-sm"
          >
            Add
          </button>

        </div>

      </div>
    </div>
  );
};

export default InstallmentModal;